// extracted by mini-css-extract-plugin
module.exports = {"card":"card--AVg9h","card_title":"card_title--_0ouT","active":"active--2TuI6"};